import { render, staticRenderFns } from "./TextToolbarMenu.vue?vue&type=template&id=13e98ead"
import script from "./TextToolbarMenu.vue?vue&type=script&lang=js"
export * from "./TextToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports